import React from 'react'
import { Field } from 'redux-form'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { translate, forms, utils } from 'parking-react-common'

import { routing, parkingLots, users } from '../redux'

import form from '../components/Form'
import Panel from '../components/Panel'
import Input from '../components/Input'
import Switch from '../components/Switch'
import Select from '../components/Select'
import ColorPickerField from '../components/ColorPickerField'
import FormContainer from '../components/FormContainer'
import FormButtons from '../components/FormButtons'

const ParkingLotBasicInfoForm = (props) => {
    const { currentValues, currentUser, t } = props
    const isEditing = !!currentValues.url
    const isStreetParking = parkingLots.isStreet(currentValues)

    return (
        <Panel title={ isEditing ? t('Basic info') : t('Add Parking Lot') } hasTable>
            <FormContainer isHorizontal>
                <Field
                    name="name"
                    label={ t('Name') }
                    placeholder={ t('Name') }
                    component={ Input }
                    isHorizontal
                />
                <Field
                    name="type"
                    label={ t('Type') }
                    component={ Select }
                    options={ utils.label('parking-lots.type') }
                    isHorizontal
                />
                <Field
                    name="spots_total"
                    label={ t('Available Spots') }
                    placeholder={ t('Available Spots') }
                    component={ Input }
                    isHorizontal
                />
                <Field
                    name="timezone"
                    placeholder={ t('Timezone') }
                    label={ t('Timezone') }
                    component={ Select }
                    options={ utils.label('parking-lots.timezone') }
                    isHorizontal
                />
                <Field
                    name="currency"
                    label={ t('Currency') }
                    component={ Select }
                    options={ utils.label('parking-lots.currency') }
                    isHorizontal
                />
                <Field
                    name="enabled"
                    label={ t('Enabled') }
                    placeholder={ t('Enabled') }
                    component={ Switch }
                    isHorizontal
                />
                { currentUser.is_staff && (
                    <Field
                        name="published"
                        label={ t('Published') }
                        placeholder={ t('Published') }
                        component={ Switch }
                        isHorizontal
                    />
                )}

                { isStreetParking && (
                    <Field
                        name="color"
                        placeholder={ t('Color') }
                        label={ t('Color') }
                        component={ ColorPickerField }
                        isHorizontal
                    />
                )}
                <FormButtons
                    onCancel={ () => {
                        routing.push(routing.routeFor('parkingLots', {
                            id     : currentValues.id,
                            action : null
                        }))
                    } }
                    { ...props }
                />
            </FormContainer>
        </Panel>
    )
}

ParkingLotBasicInfoForm.propTypes = forms.propTypes

function mapStateToProps(state) {
    return {
        currentUser: users.getCurrent(state)
    }
}

export default compose(
    translate(),
    form({ id: forms.parkingLot.id }),
    connect(mapStateToProps),
)(ParkingLotBasicInfoForm)
